import { createTracker } from '../client-js';

export default {
  bind(el, { modifiers, value }) {
    const modifierKeys = Object.keys(modifiers);

    el.analyticsHandler = createTracker(value);

    // If no modifier is provided the event is considered
    // an impression event and will be fired immidiately
    if (modifierKeys.length === 0) {
      el.analyticsHandler();
      return;
    }

    // To catch an event on the capturing phase
    // In case the element/component should be removed on click
    modifierKeys.forEach((eventName) => {
      el.addEventListener(eventName, el.analyticsHandler, true);
    });
  },
  unbind(el, { modifiers }) {
    const modifierKeys = Object.keys(modifiers);

    if (modifierKeys.length === 0) {
      return;
    }

    modifierKeys.forEach((eventName) => {
      el.removeEventListener(eventName, el.analyticsHandler, true);
    });
  },
};
